import { useLocalStorage } from "@vueuse/core";
import ISelectedImage from "../interfaces/selected-image-interface";
import ITrimPoint from "../interfaces/trim-point-interface";
import IEditData from "../interfaces/edit-data-interface";
import BaseillustMaster from "../masters/baseillust-master";

export default function imageEditorStore() {
  interface State {
    selectedImage?: ISelectedImage;
    trimPoint?: ITrimPoint;
    editData?: IEditData[];
    editCompletedImage?: String;
    uploadedImageId?: String;
  }

  const state = useLocalStorage<State>("my-storage", {
    selectedImage: null,
    trimPoint: null,
    editData: null,
    editCompletedImage: null,
    uploadedImageId: null,
  });

  return {
    resetImage(): void {
      // TODO: まとめてリセットしたい
      state.value.selectedImage = null;
      state.value.trimPoint = null;
      state.value.editData = null;
    },

    get selectedImage(): ISelectedImage {
      return state.value.selectedImage;
    },

    set selectedImage(value: ISelectedImage) {
      state.value.selectedImage = value;
    },

    hasSelectedImage(): boolean {
      return !!state.value.selectedImage;
    },

    selectImage(image: BaseillustMaster): void {
      const editImage: ISelectedImage = image; // NOTE: そのまま詰めているが必要に応じて整形
      this.selectedImage = editImage;
    },

    isSelectedImageUploaded(): boolean {
      const baseillust = new BaseillustMaster(this.selectedImage);
      if (!baseillust) {
        return false;
      }
      return baseillust.isUploaded();
    },

    get trimPoint(): ITrimPoint {
      return state.value.trimPoint;
    },

    set trimPoint(value: ITrimPoint) {
      state.value.trimPoint = value;
    },

    trimImage(trimPoint: ITrimPoint): void {
      this.trimPoint = trimPoint;
    },

    get editData(): IEditData[] {
      return state.value.editData;
    },

    set editData(value: IEditData[]) {
      state.value.editData = value;
    },

    saveEditData(editData: IEditData[]): void {
      this.editData = editData;
    },

    get editCompletedImage(): String {
      return state.value.editCompletedImage;
    },

    set editCompletedImage(value: String) {
      state.value.editCompletedImage = value;
    },

    completeEditing(completedImage: String): void {
      this.editCompletedImage = completedImage;
    },

    get uploadedImageId(): String {
      return state.value.uploadedImageId;
    },

    set uploadedImageId(value: String) {
      state.value.uploadedImageId = value;
    },

    completeUploading(uploadedImageId: String): void {
      this.uploadedImageId = uploadedImageId;
    },
  };
}

export type ImageEditorStore = ReturnType<typeof imageEditorStore>;
